var React = require('react');

function Back (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M34 23.4516H15.4811L22.0649 30L20.0865 32L10 21.9677L20.0865 12L22.0649 14L15.4486 20.5484H34V23.4516Z","fill":"black","key":1})]);
}

Back.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Back;

Back.default = Back;
